/* Stylesheet */

.settings_wrapper {
  padding: 32px;
  color: var(--ion-color-text-primary);
  --background: var(--ion-gradient-light);
  box-shadow: var(--ion-box-shadow);
  border-radius: 5px;
}
